import { render, staticRenderFns } from "./RequestTaskStatusIcon.vue?vue&type=template&id=24461519&"
import script from "./RequestTaskStatusIcon.vue?vue&type=script&lang=ts&"
export * from "./RequestTaskStatusIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports